// extracted by mini-css-extract-plugin
module.exports = {"body":"App_body__ZTvxg","pagecolumns":"App_pagecolumns__2s4bM","page":"App_page__CKP-2"};